import React from 'react';
import { Spin } from 'antd';

import { ReactComponent as Logo } from '../../assets/images/logo/Shopee_Logo_white.svg';

export default function Loading() {
  return (
    <Spin spinning wrapperClassName="loading">
      <div className="loading__img">
        <Logo className="loading__logo-svg" />
      </div>
    </Spin>
  );
}
